import { CheckCircleFill } from "react-bootstrap-icons";

import { Row, Col, Container } from "react-bootstrap";

import DOMPurify from "dompurify";

const ConfirmarSolicitudSesion = (props) => {
  const mensajeSanitizado = {
    __html: DOMPurify.sanitize(
      props.datosSolicitudSesionRegistrada.mensajeSolicitudSesionConfirmada,
      { USE_PROFILES: { html: true } }
    ),
  };

  return (
    <>
      <Container className="flex-grow-1 d-flex align-items-center justify-content-center">
        <Row>
          <Col className="text-center p-4">
            <div className="mb-4">
              <CheckCircleFill color="green" size={48} />
            </div>
            <h3 className="mb-5">Solicitud de cita registrada</h3>
            <div className="mb-4">
              Hemos registrado tu solicitud de cita en nuestra cl&iacute;nica de{" "}
              <b>
                {props.datosSolicitudSesionRegistrada.direccionCompletaSede}
              </b>{" "}
              para el{" "}
              <b>{props.datosSolicitudSesionRegistrada.fechaSolicitudSesion}</b>
              , de <b>{props.datosSolicitudSesionRegistrada.horaInicio}</b> a{" "}
              <b>{props.datosSolicitudSesionRegistrada.horaFin}</b>
            </div>
            <div className="mb-5">
              <p dangerouslySetInnerHTML={mensajeSanitizado}></p>
            </div>
            <h3>¡Gracias!</h3>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ConfirmarSolicitudSesion;
